// Module
var code = `<mat-dialog-content>
    <div class="hoa-dialog__container">
        <div class="hoa-dialog__header u-bgRed">
            <div class="u-fontWhite u-pA3">
                <h6>An error has occurred when processing your request.</h6>
            </div>
        </div>
        <div class="hoa-dialog__main">
            <div class="u-mB3 u-fontWeight700" *ngIf="data.message" [innerHTML]="data.message"></div>
            <p>
                Please contact
                <a (click)="tools.openUrl('https://www.firstcitizens.com/hosted/community-association-banking-customer-support')">
                    First Citizens Bank
                </a>
                if error persists.
            </p>
        </div>
        <div class="hoa-dialog__footer" ifOverFlowXClass="hoa-dialog__footer--overflowX">
            <button class="Button Button--link Button--minWidth130" (click)="closeDialog(0)">Close</button>
            <button class="Button Button--blue Button--minWidth130" *ngIf="!data.removeRetry" (click)="closeDialog('Retry')">Retry</button>
        </div>
    </div>
</mat-dialog-content>`;
// Exports
module.exports = code;